import * as React from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { useController } from 'react-hook-form';

import Checkbox from 'af-components/Controls/Checkbox';

import styles from './styles.module.scss';

interface OwnProps<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
	TTransformedValues = TFieldValues
> {
	control: Control<TFieldValues, TName, TTransformedValues>;
	name: TName;
	disabled?: boolean;
}

type Props<TFieldValues extends FieldValues = FieldValues, TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>, TTransformedValues = TFieldValues>
	= OwnProps<TFieldValues, TName, TTransformedValues>;

function CheckboxCell<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
	TTransformedValues = TFieldValues>(props: Props<TFieldValues, TName, TTransformedValues>) {
	const { control, name, disabled } = props;

	const { field } = useController({
		name,
		control,
	});

	const toggle = React.useCallback(() => {
		field.onChange(!field.value);
		field.onBlur();
	}, [field]);

	const className = `${styles.CheckboxCell} ${disabled ? styles.disabled : ''}`;

	return (
		<div className={className}>
			<Checkbox
				handleChange={toggle}
				isChecked={field.value}
				isDisabled={disabled}
			/>
		</div>
	);
}

export default CheckboxCell;
